import React from "react";
import { Tooltip } from "react-tooltip";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

const RemainingSessionTable = () => {
  let {
    table: { data = [], colHeaders = [], columns, rawDataLink, links }
  } = useSelector((state) => state.sessions);

  const addTooltip = (header, formattedValue) =>
    header === "Sales Package" && formattedValue.length > 32 ? (
      <span data-tooltip-id="sales-package-header-tooltip" data-tooltip-content={formattedValue}>
        {formattedValue.substring(0, 32) + "..."}
      </span>
    ) : (
      formattedValue
    );

  return data.length ? (
    <>
      <Tooltip id="sales-package-header-tooltip" />
      <TableWithCustomSearch
        data={data}
        links={links}
        colHeaders={colHeaders}
        columns={columns}
        rawDataLink={rawDataLink}
        tableWrapperId="remainingSessionTable"
        fileName="remaining-sessions"
        dateConversion={false}
        customFn={(header, formattedValue) => addTooltip(header, formattedValue)}
      />
    </>
  ) : null;
};

export default RemainingSessionTable;
